import { getAddressesClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

interface AddressDetailsData {
  zip: string
  lat: number
  long: number
}

type AddressDetailsResponse = AddressDetailsData | null

const getAddressDetails = async (
  zipCode: string
): Promise<AddressDetailsResponse> => {
  try {
    const addressDetailClient = getAddressesClient()
    const axiosParams = {
      ...buildAxiosRequestConfig({ accessToken: null }),
      validateStatus: () => true,
    }

    const response = await addressDetailClient.addressDetails(
      { zip: zipCode },
      axiosParams
    )

    if (response.status !== 200) {
      return null
    }

    const addressDetail = response.data
    return {
      zip: addressDetail.zip,
      lat: addressDetail.lat,
      long: addressDetail.long,
    }
  } catch {
    return null
  }
}

export default getAddressDetails
